var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/util/optional-motion.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Motion } from 'react-motion';
import { useSettings } from 'soapbox/hooks';
import ReducedMotion from './reduced-motion';

const OptionalMotion = props => {
  const reduceMotion = useSettings().get('reduceMotion');
  return reduceMotion ? /*#__PURE__*/React.createElement(ReducedMotion, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 20
    }
  })) : /*#__PURE__*/React.createElement(Motion, _extends({}, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 51
    }
  }));
};

export default OptionalMotion;